import $axios from './http'

//获取新闻
export const getNewsInfo = (data) => {
    return $axios.get('/news/list_all', {
        params: data
    })
}

//获取资质
export const getHonorInfo = (data) => {
    return $axios.get('honor/list_all', {
        params: data
    })
}